import { CREW_ORDER } from "../crewData";
import type { WorldsContent } from "../worldsContent";
import { CS_CREW, CS_WORLD_PAGES } from "./csCrew";

/**
 * Home-page block "Který z nich jste vy?" for bidmio.cz. The Czech split is
 * honest about local data: price pressure from cheaper competitors and late
 * payers on one side, growth without order on the other. No claim that most
 * tradespeople live month to month.
 */
export const CS_WORLDS: WorldsContent = {
  lang: "cs",
  crew: CS_CREW,
  order: CREW_ORDER,
  pages: CS_WORLD_PAGES,
  doors: {
    survive: {
      quotes: [
        "Levnější mě podstřelil o třetinu.",
        "Na výplaty zase nezbylo.",
        "Vzal jsem to pod cenou. Leasing nepočká.",
        "Dva měsíce čekám na peníze.",
      ],
      points: [
        "Zákazník chce slevu a levnější konkurence bere hotovost.",
        "Peníze máte vydělané, jen ještě nepřišly.",
      ],
    },
    grow: {
      quotes: [
        "Práce mám na půl roku. Nestíhám.",
        "Dva jsou na neschopence a střecha stojí.",
        "Kam zmizelo 40 metrů kabelu?",
        "Obrat roste. Peněz ubývá.",
      ],
      points: [
        "Lidí přibývá a s nimi přihlášky, dovolené, neschopenky a ztráty.",
        "Obrat roste, a na účtu je stejně méně.",
      ],
    },
  },
  ui: {
    heading: "Který z nich jste vy?",
    subheading: "Klikněte na toho, kdo je vám nejblíž, a podívejte se, kam dál.",
    lineupAria: "Vyberte, kdo je vám nejblíž",
    doorsBadge: "Řekněme si to na rovinu",
    doorsTitle: "Kde jste dnes?",
    doorsIntro:
      "Někdo bere každou zakázku, protože zákazník chce slevu a peníze chodí pozdě. Jiný má práce tolik, že nestíhá. Těžké je obojí, jen jinak.",
    doorLabel: "Dveře",
    doorCta: "Tohle jsem já",
    doorsFooter: "Jste někde mezi? Podívejte se na oboje.",
  },
};
